import script from "./LoginCustomer.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginCustomer.vue?vue&type=script&setup=true&lang=js"

import "./LoginCustomer.vue?vue&type=style&index=0&id=b9c07836&lang=css"

const __exports__ = script;

export default __exports__